// extracted by mini-css-extract-plugin
export default {"title":"OrderDetails_title__kvhhN","container":"OrderDetails_container__xgWXV","details":"OrderDetails_details__ThkY2"};